import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from './utilities/http';
import {Hall, IFetchHallsDto} from '../common/interfaces/hall';
import {toQueryString} from "../utilities/helpers";

export const fetchAllHalls = async (data: IFetchHallsDto) => {
  return await getRequest('/hall?' + toQueryString(data));
};

export const fetchHallByID = async (hallID:number) => {
  return await getRequest('/hall/' + hallID);
};

export const insertHall = async (data: Hall) => {
  return await postRequest('/hall', data);
};

export const updateHall = async (data: Hall) => {
  return await patchRequest('/hall', data);
};

export const deleteHall = async (id: Number) => {
  return await deleteRequest('/hall/' + id);
};
export const deleteFloorPlan = async (id: number) => {
  return await deleteRequest(`/floor-plan/${id}`);
};
